import React from 'react';
import { CheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
const benefits = ['Implement in 24 hours — the sprint guide is included', 'Works in any market condition, in any of 12 countries', '7-day money-back guarantee, no questions asked'];
const trust = [{
  icon: LockIcon,
  label: 'Secure checkout'
}, {
  icon: CreditCardIcon,
  label: 'Stripe approved'
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function FinalCTASection() {
  return <section id="get-access" className="relative w-full overflow-hidden bg-navy-800 py-20 lg:py-28" aria-labelledby="cta-heading" data-id="element-27" data-mp="34cv4ggmvxr1l">
      <div aria-hidden="true" className="pointer-events-none absolute -left-40 top-0 h-[520px] w-[520px] rounded-full bg-navy-700 opacity-70 blur-3xl animate-drift" data-id="element-28" data-mp="3e24wxxln5bq8" />
      <div aria-hidden="true" className="pointer-events-none absolute -right-32 bottom-0 h-[420px] w-[420px] rounded-full bg-brand-gold/10 blur-3xl animate-drift" data-id="element-29" data-mp="2gmr4qkctibfv" />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 lg:grid-cols-[3fr_2fr] lg:px-8" data-id="element-30" data-mp="26tzd40uoor6a">
        <Reveal data-id="element-31" data-mp="21wpq0rurorlm">
          <h2 id="cta-heading" className="text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-32" data-mp="21ya8vk7pym3n">
            Ready to dominate your market?
          </h2>
          <p className="mt-4 max-w-xl text-lg leading-relaxed text-slate-300" data-id="element-33" data-mp="1s5ususfzg7le">
            Join 2,000+ agents who&rsquo;ve already transformed their business with AI.
          </p>

          <ul className="mt-8 space-y-3" data-id="element-34" data-mp="1j3v8pr9o8ne8">
            {benefits.map(benefit => <li key={benefit} className="flex items-start gap-3 text-[15px] font-medium text-slate-200" data-id="element-35" data-mp="1e5tt5gbgf67i">
                <CheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-brand-gold" data-id="element-36" data-mp="1981wk8zv6vwz" />
                {benefit}
              </li>)}
          </ul>

          <div className="mt-10" data-id="element-37" data-mp="38i0ayxyusl8s">
            <CTAButton href="https://the-real-estate-growth-system.impultienda.ar/checkout" data-id="element-38" data-mp="33l1n2x5s9aj1">GET THE SYSTEM NOW — $24 USD</CTAButton>
            <p className="mt-4 text-sm text-slate-400" data-id="element-39" data-mp="11ujbec8wi0xp">
              Limited time: includes all 5 bonuses{' '}
              <span className="font-semibold text-brand-gold" data-id="element-40" data-mp="16ox7yhzaue3y">free</span>.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-41" data-mp="wx0xe7g10viu">
          <div className="overflow-hidden rounded-2xl border border-white/10 shadow-2xl" data-id="element-42" data-mp="ww9enx7j2s9z">
            <img src="https://cdn.magicpatterns.com/uploads/6vCQHvuwre57PFkVP21XN8/comprimida-final.png" alt="Real estate agent celebrating a closed deal in a modern city office" className="h-full w-full object-cover" width={1200} height={900} style={{
            height: "333px"
          }} data-id="element-43" data-mp="1km3r4dnxqetp" />
          </div>
          <ul className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3" data-id="element-44" data-mp="1fn8wmeglv1tr">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-xs font-semibold text-slate-400" data-id="element-45" data-mp="575v4860eyt">
                <Icon aria-hidden="true" className="h-4 w-4" data-id="element-46" data-mp="49olqsbem84b" />
                {label}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}